module.exports = require("./fr-CM.d.ts");